var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("collapsible-card", {
    attrs: {
      "collapse-id": "participants-card",
      "store-path": "clientProfileParticipants",
    },
    on: { hidden: _vm.handleCardCollapsed },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function (ref) {
          var collapsed = ref.collapsed
          return [
            _c("span", [_vm._v(_vm._s(_vm.cardTitle))]),
            _vm._v(" "),
            !collapsed
              ? _c(
                  "div",
                  { staticClass: "coapp-actions d-flex align-items-center" },
                  [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value: {
                              title: _vm.t(
                                "client-profile.participants.editParticipants"
                              ),
                            },
                            expression:
                              "{\n          title: t('client-profile.participants.editParticipants')\n        }",
                          },
                        ],
                        staticClass: "clickable mr-2",
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-cog",
                          attrs: { "aria-hidden": "true" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.toggleEditing()
                            },
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value: {
                              title: _vm.t(
                                "client-profile.participants.addParticipants"
                              ),
                            },
                            expression:
                              "{\n          title: t('client-profile.participants.addParticipants')\n        }",
                          },
                        ],
                        staticClass: "clickable",
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-plus text-primary",
                          attrs: { "aria-hidden": "true" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.toggleCreating()
                            },
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.loading
              ? _c("participants-loader")
              : _vm.editing
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "draggable",
                      {
                        attrs: {
                          id: "participants-draggable-container",
                          animation: 200,
                          draggable: ".sortable",
                          "ghost-class": "ghost",
                          handle: ".sortable-handle",
                        },
                        on: {
                          end: function ($event) {
                            return _vm.handleSortEnd()
                          },
                        },
                        model: {
                          value: _vm.participants,
                          callback: function ($$v) {
                            _vm.participants = $$v
                          },
                          expression: "participants",
                        },
                      },
                      _vm._l(_vm.participants, function (participant) {
                        return _c(
                          "div",
                          {
                            key: participant.id,
                            staticClass: "row align-items-center sortable",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex w-100 align-items-center",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "sortable-handle mr-2 cursor-move",
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-bars",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("material-input", {
                                  staticClass:
                                    "display-participant flex-grow-1",
                                  attrs: {
                                    value:
                                      participant.firstName +
                                      " " +
                                      participant.lastName,
                                    label:
                                      _vm.translatedReferrerTypes[
                                        participant.type
                                      ] ||
                                      _vm.t(
                                        "client-profile.participants.custom"
                                      ),
                                    "read-only": "",
                                    "inner-input-classes": [
                                      "participants-material-input",
                                    ],
                                    "label-color": "black",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip",
                                        value: {
                                          title: _vm.t(
                                            "client-profile.participants.removeParticipant"
                                          ),
                                        },
                                        expression:
                                          "{\n                title: t('client-profile.participants.removeParticipant')\n              }",
                                      },
                                    ],
                                    staticClass: "ml-2 clickable",
                                  },
                                  [
                                    _c(
                                      "inline-prompt",
                                      {
                                        staticClass: "clickable",
                                        staticStyle: { "font-size": "0.8rem" },
                                        attrs: {
                                          "action-type": "delete",
                                          placement: "left",
                                          "confirmation-text": _vm.t(
                                            "client-profile.participants.removeParticipantQuestion"
                                          ),
                                        },
                                        on: {
                                          accept: function ($event) {
                                            return _vm.removeParticipant(
                                              participant.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa fa-trash text-danger",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip",
                                        value: {
                                          title: _vm.t(
                                            "client-profile.participants.toggleVisibility"
                                          ),
                                        },
                                        expression:
                                          "{\n                title: t('client-profile.participants.toggleVisibility')\n              }",
                                      },
                                    ],
                                    staticClass: "ml-2 clickable",
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleParticipantVisibility(
                                          participant
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      class: [
                                        "fa",
                                        participant.cardVisibility
                                          ? "fa-eye"
                                          : "fa-eye-slash",
                                      ],
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                )
              : _vm.creating
              ? _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "material-input",
                        {
                          staticClass: "form-group-material-no-label text-left",
                          model: {
                            value: _vm.newParticipantType,
                            callback: function ($$v) {
                              _vm.newParticipantType = $$v
                            },
                            expression: "newParticipantType",
                          },
                        },
                        [
                          _c("select2", {
                            attrs: {
                              name: "newParticipantType",
                              value: _vm.newParticipantType,
                              data: _vm.referrerTypes,
                              options: {
                                placeholder: _vm.t(
                                  "client-profile.participants.participantType"
                                ),
                              },
                            },
                            on: { change: _vm.handleNewParticipantTypeChange },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.newParticipantType && _vm.newParticipantType !== "custom"
                    ? _c(
                        "div",
                        { staticClass: "row mt-3" },
                        [
                          _c(
                            "material-input",
                            {
                              staticClass:
                                "form-group-material-no-label text-left",
                              model: {
                                value: _vm.newParticipantReferrerID,
                                callback: function ($$v) {
                                  _vm.newParticipantReferrerID = $$v
                                },
                                expression: "newParticipantReferrerID",
                              },
                            },
                            [
                              _c("select2", {
                                attrs: {
                                  name: "newParticipantReferrerID",
                                  value: _vm.newParticipantReferrerID,
                                  data: _vm.filteredReferrers,
                                  options: _vm.newParticipantReferrerIDOptions,
                                },
                                on: {
                                  change:
                                    _vm.handleNewParticipantReferrerIDChange,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.newParticipantType && _vm.newParticipantType === "custom"
                    ? _c(
                        "div",
                        { staticClass: "row mt-4" },
                        [
                          _c("material-input", {
                            staticClass: "display-participant",
                            attrs: {
                              "validator-context": _vm.$v,
                              label: _vm.t(
                                "client-profile.participants.customParticipantFirstName"
                              ),
                              "required-indicator": "",
                            },
                            model: {
                              value:
                                _vm.newParticipantReferrerDetails.firstName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.newParticipantReferrerDetails,
                                  "firstName",
                                  $$v
                                )
                              },
                              expression:
                                "newParticipantReferrerDetails.firstName",
                            },
                          }),
                          _vm._v(" "),
                          _c("material-input", {
                            staticClass: "display-participant",
                            attrs: {
                              "validator-context": _vm.$v,
                              label: _vm.t(
                                "client-profile.participants.customParticipantLastName"
                              ),
                              "required-indicator": "",
                            },
                            model: {
                              value: _vm.newParticipantReferrerDetails.lastName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.newParticipantReferrerDetails,
                                  "lastName",
                                  $$v
                                )
                              },
                              expression:
                                "newParticipantReferrerDetails.lastName",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              attrs: {
                                value: _vm.newParticipantReferrerDetails.phone,
                                label: _vm.t(
                                  "client-profile.participants.customParticipantPhone"
                                ),
                                "validator-context": _vm.$v,
                                "required-indicator": "",
                              },
                            },
                            [
                              _c("phone-input", {
                                staticClass: "material-input form-control form",
                                class: {
                                  "form-control-filled":
                                    !!_vm.newParticipantReferrerDetails.phone,
                                },
                                attrs: {
                                  name: "new-participant-phone",
                                  "data-lpignore": "true",
                                  type: "text",
                                  value:
                                    _vm.newParticipantReferrerDetails.phone,
                                  "emit-value": true,
                                },
                                on: {
                                  change: _vm.handleNewParticipantPhoneChange,
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "d-none",
                                  attrs: { for: "new-participant-phone" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.t(
                                        "client-profile.participants.customParticipantPhone"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("material-input", {
                            staticClass: "display-participant",
                            attrs: {
                              "validator-context": _vm.$v,
                              label: _vm.t(
                                "client-profile.participants.customParticipantEmail"
                              ),
                              type: "email",
                              "required-indicator": "",
                            },
                            model: {
                              value: _vm.newParticipantReferrerDetails.email,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.newParticipantReferrerDetails,
                                  "email",
                                  $$v
                                )
                              },
                              expression: "newParticipantReferrerDetails.email",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-end mt-3 w-100" },
                      [
                        _c("simple-button", {
                          attrs: {
                            "class-name": "btn-sm mr-4",
                            text: _vm.t("client-profile.participants.cancel"),
                            loading: _vm.loading,
                            type: "danger",
                            disabled: _vm.loading,
                          },
                          on: { click: _vm.handleCancelNewParticipantClick },
                        }),
                        _vm._v(" "),
                        _c("simple-button", {
                          attrs: {
                            "class-name": "btn-sm",
                            disabled:
                              !_vm.enableSaveButtonAddParticipant ||
                              _vm.loading,
                            text: _vm.t("client-profile.participants.save"),
                            loading: _vm.loading,
                          },
                          on: { click: _vm.handleAddNewParticipantClick },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _vm._l(_vm.participants, function (participant) {
                      return _c(
                        "div",
                        { key: participant.id, staticClass: "row" },
                        [
                          _c(
                            "b-popover",
                            {
                              attrs: {
                                target: "participant-" + participant.id,
                                triggers: "hover focus",
                                placement: "right",
                              },
                            },
                            [
                              _c("div", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.t("client-profile.participants.name")
                                    ) + ":"
                                  ),
                                ]),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(participant.firstName) +
                                    " " +
                                    _vm._s(participant.lastName)
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.t("client-profile.participants.type")
                                    ) + ":"
                                  ),
                                ]),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.translatedReferrerTypes[
                                        participant.type
                                      ] ||
                                        _vm.t(
                                          "client-profile.participants.custom"
                                        )
                                    )
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.t("client-profile.participants.email")
                                    ) + ":"
                                  ),
                                ]),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(participant.email || "N/A")
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.t("client-profile.participants.phone")
                                    ) + ":"
                                  ),
                                ]),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(participant.phone || "N/A") +
                                    "\n          "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("material-input", {
                            staticClass: "display-participant",
                            attrs: {
                              id: "participant-" + participant.id,
                              value:
                                participant.firstName +
                                " " +
                                participant.lastName,
                              label:
                                _vm.translatedReferrerTypes[participant.type] ||
                                _vm.t("client-profile.participants.custom"),
                              "read-only": "",
                              "inner-input-classes": [
                                "participants-material-input",
                              ],
                              "label-color": "black",
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _vm.participants.length == 0
                      ? _c("p", [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.t(
                                  "client-profile.participants.noParticipants"
                                )
                              ) +
                              "\n      "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }